import type { UIRouter } from '@wix/tpa-router';
import type { ControllerParams } from '@wix/yoshi-flow-editor';

import { SECRET_SLUG } from '@wix/social-groups-serverless/dist/groups/constants';

export function editorDefaults(router: UIRouter, params: ControllerParams) {
  const { isEditor, isPreview } = params.flowAPI.environment;

  // path: ['group', 'release-notes', 'discussion']
  const slug = params.flowAPI.controllerConfig.wixCodeApi.location.path[1];

  if (isEditor || isPreview) {
    router.urlService.rules.initial({
      state: 'group.discussion.feed',
      params: { slug: slug || SECRET_SLUG },
    });
  }
}
